import _ from 'lodash';
import {
  getDeviceId,
  getModel,
  getBrand,
  getVersion,
  getDeviceType,
  getModelCode,
} from './src/platform/default/device';

export { getDeviceId, getModel, getBrand, getVersion, getDeviceType, getModelCode };

/**
 * Retrieve all infos of the given device
 *
 * @async
 * @throws
 * @return {Object}
 */
const getAllDeviceInfo = async () => {
  const [brand, deviceId, deviceType, model, modelCode, version] = await Promise.allSettled([
    getBrand(),
    getDeviceId(),
    getDeviceType(),
    getModel(),
    getModelCode(),
    getVersion(),
  ]);

  return _.mapValues({ brand, deviceId, deviceType, model, modelCode, version }, (promiseSettledValue, key) => {
    if (promiseSettledValue.status === 'fulfilled') {
      return promiseSettledValue.value;
    }

    // eslint-disable-next-line no-console
    console.warn(`Getting ${key} failed`, promiseSettledValue.reason);

    return '';
  });
};

export const deviceInfo = {
  getBrand,
  getDeviceId,
  getDeviceType,
  getModel,
  getModelCode,
  getVersion,
  getAllDeviceInfo,
};
